export default "__VITE_ASSET__EYOqHh85__"